<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    民治站<br>
站点介绍<br>
民治站位于民治大道与平南铁路交叉口东侧。车站东南侧为民治樟坑社区，西侧为深圳北站，北侧为民治村社区及民治小学。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:09	23:38	5号线	3分钟	5分25秒<br>
黄贝岭	06:09	23:43	5号线	3分钟	5分25秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:01	23:38	5号线	4分钟	6分钟<br>
黄贝岭	05:59	23:43	5号线	4分钟	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:01	00:38	5号线	4分钟	6分钟<br>
黄贝岭	05:59	00:43	5号线	4分钟	6分钟<br><br>

站点出口信息<br><br>
A出入口:<br>
民治大道西侧（南）、民德路南侧（西）、民康路西侧、樟坑一区<br><br>
B出入口:<br>
民治大道东侧、民新社区工作站、民德路南侧（东）、民康路东侧<br><br>
D出入口:<br>
民治大道西侧（北）、民德路北侧、樟坑二区、东边商务大楼、民治小学、沙元埔村、朝阳新村<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 民治地铁站<br>
333、620、E7、M112、M152、M156、M193、M225、M262、M282、M302、M500、M577、M392、B917B、高峰专线122<br><br>
B出入口:<br>
公交站名： 民治地铁站<br>
333、620、M112、高峰专线122、M152、M156、M193、M225、M262、M282、M302、M392、M500、M577、E7、B917A<br><br>
D出入口:<br>
公交站名： 沙元埔<br>
324、334、339、621、M173、M365、M391、M398、M537、高峰专线34、高快巴士42号<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "wuhaoxian",
          title: "5号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>


